import { useState } from "react";
import { getAPIRequest } from "../Axios/AxiosRequestConfiguration";
import getRequestInterface from "../Axios/getRequestInterface";

export const useGetApi = (
  onSuccess: (data: any) => void,
  onError: (error: any) => void
) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);
  const [responseData, setResponseData] = useState<any>(null);

  const makeRequest = async (url: string) => {
    setLoading(true);
    await getAPIRequest({
      url: url,
      success: (response: any) => {
        setResponseData(response["data"]);
        onSuccess(response["data"]);
        setLoading(false);
      },
      failure: (err: any) => {
        setLoading(false);
        setError(err);
        onError(err);
      },
    } as getRequestInterface);
  };

  return { makeRequest, loading, responseData, error };
};
